import moment from 'moment';
import utils from '../lib/utils';
import {v4 as uuid}  from 'uuid';

const queryStartDate = utils.formatDate(new Date('22 Feb 2013 00:00:00'));
const queryEndDate = utils.formatDate(Date.now());

export default {
  attachments: {
    failed: [],
    forUploading: []
  },
  pipeline: [],
  pipelineError: false,
  pipelinePagination: {
    totalPages: 1,
    currentPage: 1
  },
  pipelineQuery: {
    startDate: queryStartDate,
    endDate: queryEndDate,
    newOrRenewal: '',
    stageName: '',
    sort: null,
    order: null,
    searchParam: ''
  },
  leads: [],
  leadsError: false,
  latestApprovalsQuery: {
    startDate: moment().subtract(30, 'days'),
    endDate: moment(),
    newOrRenewal: null,
    stageName: 'Approved',
    sort: null,
    order: null,
    searchParam: undefined
  },
  latestApprovals: [],
  latestApprovalsError: false,
  latestApprovalsLoadMore: {},
  latestContractsQuery: {
    startDate: moment().subtract(30, 'days'),
    endDate: moment(),
    newOrRenewal: null,
    stageName: 'Contract Out',
    sort: null,
    order: null,
    searchParam: undefined
  },
  latestContracts: [],
  latestContractsError: false,
  latestContractsLoadMore: {},
  portfolio: [],
  portfolioError: false,
  portfolioPagination: {
    totalPages: 1,
    currentPage: 1
  },
  portfolioQuery: {
    startDate: queryStartDate,
    endDate: queryEndDate,
    portfolioStatus: '',
    include: '',
    show: '',
    searchParam: '',
    sort: null,
    order: null,
    export: false
  },
  kpis: {},
  mtd: true,
  submissionsType: "New",
  chartDataType: "newMTD",
  submission: {
    owners: [],
    has_current_loan: false
  },
  submissionInfo: {
    form: {
      section: 1,
      files: [],
      name: ""
    },
    submission: {
      success: null,
      info: {},
      isLoading: false
    },
    allFilesUploaded: false,
    statusOfCurrentAttachments: []
  },
  user: {},
  partner: {
    options: [],
    selected: null,
    fundingPartnerData: {}
  },
  requestedStipsInfo: {
    requestedStips: [],
    owners: [],
    ownersLoaded: false,
    requestedStipsFormInfo: {
      files: []
    }
  },
  modal: {
    className: '',
    error: false,
    link: null,
    onClose: () => {},
    showModal: false,
    message: null
  },
  contacts: {},
  uuid: uuid()
};
